export default __webpack_public_path__ + "static/media/LandingPageOne.a21940fc.png";